var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIterateTowardsExcellence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFAE00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.804 2695.193l2.923 2.338c.172.137.273.346.273.566 0 .22-.1.428-.273.566l-2.923 2.337v-1.452h-9.222c1.058-.468 2.062-1.047 2.996-1.727.51-.363.998-.756 1.462-1.176h4.764v-1.452zm-2.163-14.077c.222 0 .431.1.57.272l.73.944 1.593 1.974h-1.46c0 8.418-6.87 15.242-15.345 15.242H266.73c-.404 0-.731-.325-.731-.725v-1.452c0-.401.327-.726.73-.726h18.999c6.86 0 12.421-5.524 12.421-12.34h-1.461l1.344-1.669 1.038-1.248c.139-.172.348-.272.57-.272zm-25.56 7.501c1.061 2.822 3.125 5.161 5.802 6.576h-4.896c-1.299-1.255-2.363-2.73-3.141-4.355zm11.648-11.57c4.035 0 7.307 3.25 7.307 7.259 0 4.008-3.272 7.258-7.307 7.258-4.036 0-7.307-3.25-7.307-7.258 0-4.009 3.271-7.259 7.307-7.259zm3.843 4.377c-.253-.067-.523.005-.709.189l-4.23 4.21-2.039-2.033c-.137-.137-.324-.214-.519-.214s-.381.077-.519.214-.216.322-.216.516c0 .193.078.379.216.515l2.558 2.54c.137.138.324.215.519.215.194 0 .381-.077.518-.214l4.75-4.718c.185-.184.258-.453.19-.704-.068-.252-.266-.448-.519-.516zm-7.472-11.99c6.898-1.668 14.048 1.583 17.285 7.86.142.281.086.621-.139.842l-1.096 1.089c-.166.17-.405.25-.641.212-.236-.037-.439-.187-.542-.4-2.479-5.23-8.279-8.048-13.956-6.784-5.677 1.264-9.71 6.273-9.704 12.053h1.461l-1.373 1.677-1.009 1.248c-.138.172-.348.272-.57.272-.221 0-.431-.1-.57-.272l-.73-.944v-.007l-1.593-1.974h1.461c-.029-7.053 4.817-13.204 11.716-14.872z",
    transform: "translate(-266 -2669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIterateTowardsExcellence);
export default __webpack_public_path__ + "static/media/icon-iterate-towards-excellence.fa699fdd41686f0ceebebcdf990aebc2.svg";
export { ForwardRef as ReactComponent };